/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationTiming {
    getFixupPrototypeFunction() { return ScheduleRecommendationTiming.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationTiming>): ScheduleRecommendationTiming {
        let obj = Object.assign(new ScheduleRecommendationTiming(), model);
        ScheduleRecommendationTiming.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationTiming>): ScheduleRecommendationTiming {
        if (!model) return null;
        return ScheduleRecommendationTiming.newInstance(<ScheduleRecommendationTiming> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationTiming) {
        if (!obj) return;

        models.ScheduleRecommendationTiming.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationTiming): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationTiming.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cost_savings_monthly === undefined) {
            this.cost_savings_monthly = 0;
        }
    }

    /**
     * Recommended schedule periods. For hourly recommendations this contains hour offsets in seconds; for weekly recommendations this contains day names.
     */
    schedule_periods: Array<string>;

    day: models.DayOfWeek;

    /**
     * Recommended schedule start time in HH:MM:SS format
     */
    from_time: string;

    /**
     * Recommended schedule end time in HH:MM:SS format
     */
    to_time: string;

    /**
     * Monthly savings for this schedule period
     */
    cost_savings_monthly: number;

}
